import { Directive } from '@angular/core';
import { ColorStatusDirective } from './../../directives';

@Directive({
	selector: '[appColorStatus]',
	standalone: true
})
export class FormColorStatusDirective extends ColorStatusDirective {}
